import type { ComponentPropsWithoutRef, FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { TypographyV2 } from '../../Seatbelt2/Foundations/Typography'

export const ImageCaption: FunctionComponent<Props> = ({
  caption,
  className,
  ...rest
}) => (
  <TypographyV2
    tag="figcaption"
    textStyle="sb-text-interface-body-x-small-regular"
    data-testid="image-caption"
    className={classnames(className)}
    {...rest}
  >
    {caption}
  </TypographyV2>
)

///////// IMPLEMENTATION /////////

type Props = {
  /**
   * Caption to be displayed below the image
   */
  caption: string
  /**
   * Class name to be added to the component for additional styling/spacing purposes.
   */
  className?: string
} & ComponentPropsWithoutRef<'figcaption'>
